export default "__VITE_ASSET__1d0938bc__"